<template>
  <div class="kind-wrap">
    <div class="sale" :class="{'active': saleSelected}" v-if="isSale" @click="goSale">查看折扣商品</div>
    <div class="kind-list" v-if="categories && categories.length">
      <div class="tit">分类
        <div v-if="categories.length > 9" class="more" @click="getMore('cate')"><p>{{ hideCate ? '更多':'收起' }}</p><div class="icon" :class="{'hide': !hideCate}"></div></div>
      </div>
      <div class="ul-list" :class="{'hide-cate': hideCate}">
        <div 
          class="list" 
          v-for="(item, index) in categories"
          :class="{
            'cancel-margin': (index + 1) % 3 == 0,
            'active': selected[item.id]
          }"
          @click="selectItem(item.id, 'cate', item.name, $event)">
          {{ item.name }}
        </div>
      </div>

      <!-- <div class="more" v-if="!hideCate && categories.length" data-type="cate">更多分类 <div class="more-icon"></div></div> -->
    </div>

    <div class="kind-list" v-if="brands && brands.length">
      <div class="tit">品牌
        <div v-if="brands.length > 9" class="more" @click="getMore('brand')"><p>{{ hideBrand ? '更多':'收起' }}</p><div class="icon" :class="{'hide': !hideBrand}"></div></div>
      </div>
      <div class="ul-list" :class="{'hide-cate': hideBrand}">
        <div 
          class="list"
          v-for="(item, index) in brands"
          :class="{
            'cancel-margin': (index + 1) % 3 == 0,
            'active': selected[item.id]
          }"
          @click="selectItem(item.id, 'brand', item.name, $event)">
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="kind-list" v-if="hots && hots.length">
      <div class="tit">热门标签
        <p></p>
      </div>
      <div class="ul-list">
        <div 
          class="list"
          v-for="(item, index) in hots"
          :class="{
            'cancel-margin': (index + 1) % 3 == 0,
            'active': selected[item.id]
          }"
          @click="selectItem(item.id, 'hot', item.name, $event)">
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="kind-footer">
      <span class="reset" :class="{'active':isReset}" @click="goReset">重置筛选项</span>
      <span class="select" @click="goSelect">确定</span>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/app-header'
import browser from '@beastshop/browser'

import cateList from './more-list'

import {
  getFilter
} from '../apis'

export default {
  components: {
    cateList,
    AppHeader
  },

  props: ['selectObject', 'clearFilter', 'discountSelected'],

  data () {
    return {
      query: '',
      categories: null,
      brands:null,
      hots: null,
      selected: {},
      nameSelected: {},
      isReset: false,
      hideCate: false,
      hideBrand: false,
      isSale: false,
      saleSelected: false,
      isWechat: browser.weixin()
    }
  },

  created () {
    this.initQuery()
    this.getCateg(this.query)

    
  },

  watch: {
    selectObject () {
      this.saleSelected = this.discountSelected
      if (this.clearFilter) {
        this.initQuery()
        this.getCateg(this.query)
      }
    }
  },

  methods: {
    initQuery () {
      let {
        selected,
        que
      } = this.selectObject

      const tempSel = {}
      if (selected) {
        const cate = selected.split(',')
        cate.forEach((item, index) => {
          const select = item.split('_')
          select.forEach(sel => {
            if (sel) {
              let tag = 'hot'
              switch (index) {
                case 0:
                  tag = 'cate'
                  break
                case 1: 
                  tag = 'brand'
                  break
              }
              tempSel[sel] = tag
            }
          })
        })
      }
      
      // 
      que = que.replace(/(&)+$/, '')

      this.query = `${que}&selected=${selected}`
      this.selected = tempSel
      this.isReset = Object.keys(tempSel).length
    },

    getCateg (query, notDel) {
      this.$showLoading()
      getFilter(query)
      .then(({ data }) => {
        this.$hideLoading()
        this.categories = data[1].items
        this.brands = data[2].items, // 品牌
        this.hots = data[3].items // 热门

        this.isSale = data[0].items.length ? true : false

        if (!notDel) {
          this.delSelected()
        }

        if (this.categories.length > 9 && !this.getIsSelected('cate')) {
          this.hideCate = true
        }

        if (this.brands.length > 9 && !this.getIsSelected('brand')) {
          this.hideBrand = true
        }
      })
    },

    delSelected () {
      const {
        categories,
        brands,
        hots,
        selected,
        nameSelected
      } = this

      const collects = []
      const temp = {}

      categories.forEach(el => {
        collects.push(el.id)
      })

      brands.forEach(el => {
        collects.push(el.id)
      })

      hots.forEach(el => {
        collects.push(el.id)
      })
      
      for (const k in selected) {
        const sel = selected[k]
        
        if (~collects.indexOf(k)) {
          temp[k] = sel
        }
        else {
          delete nameSelected[k]
        }
      }

      this.selected = temp
      this.nameSelected = nameSelected
      this.isReset = Object.keys(temp).length
    },

    getIsSelected (type) {
      for (const key in this.selected) {
        if (this.selected[key] === type) {
          return true
        }
      }

      return false
    },

    goSelect () {
      let query = this.query
      let cateSelected = ''
      let brandSelected = ''
      let hotSelected = ''

      Object.keys(this.selected).forEach(i => {
        const type = this.selected[i]
        if (type === 'cate') {
          cateSelected += `${i}_`
        }
        if (type === 'brand') {
          brandSelected += `${i}_`
        }

        if (type == 'hot') {
          hotSelected += `${i}_`
        }
      })

      const selected = {
        cateSelected,
        brandSelected,
        hotSelected
      }

      query = query.replace(/(&)+$/, '')
      const tempQuery = query.replace(/selected=[A-Za-z0-9_,]+&?/g, '').replace(/(discountOnly=true&)$/, '')

      if (this.saleSelected) {
        query = `${tempQuery}discountOnly=true&`
      }
      else {
        query = `${tempQuery}selected=${cateSelected},${brandSelected},${hotSelected}&`
      }

      let _cateSelected = ''
      let _brandSelected = ''
      let _hotSelected = ''
  
      Object.keys(this.nameSelected).forEach(i => {
        const obj = this.nameSelected[i]
        const type = obj.type
        const name = obj.name

        if (type === 'cate') {
          _cateSelected += `${name}_`
        }
        if (type === 'brand') {
          _brandSelected += `${name}_`
        }

        if (type == 'hot') {
          _hotSelected += `${name}_`
        }
      })
      
      sa.track('CommodityScreen', {
        screen_classify: _cateSelected.split('_'), 
        screen_brand_commodity: _brandSelected.split('_'),
        hot_label: _hotSelected.split('_')
      })

      this.$emit('select', query, selected, this.saleSelected, Object.keys(this.selected).length)
    },

    goSale () {
      this.saleSelected = !this.saleSelected

      this.isReset = this.saleSelected       
      if (this.saleSelected) {
        this.selected = {}
        this.getCateg(`&selected=,,,&${this.query}`, true)
      }
    },

    selectItem (id, type,name, e) {
      const tar = e.currentTarget
      const isActive = tar.dataset.active

      const {
        selected,
        nameSelected,
        query
      } = this

      if (id in selected) {
        delete selected[id]
        delete nameSelected[id]
        tar.classList.remove('active')
      }
      else {
        selected[id] = type
        nameSelected[id] = {
          type,
          name
        }
        tar.classList.add('active')
      }

      this.selected = selected
      this.nameSelected = nameSelected
      this.isReset = Object.keys(selected)

      this.saleSelected = false

      const selQue = this.formatSeled()

      this.getCateg(`&selected=${selQue}&${query}`)
    },

    goReset: function () {
      const {
        isReset, 
        query
      } = this

      if (isReset) {
        this.getCateg(`&selected=,,,&${query}`)
      }

      this.selected = {}
      this.nameSelected = {}
      this.isReset = false
      this.saleSelected = false
    },
    
    getMore (type) {
      if (type === 'brand') {
        this.hideBrand = !this.hideBrand
      }
      else {
        this.hideCate = !this.hideCate
      }
    },

    formatSeled: function () {
      let cateQue = ''
      let brandQue = ''
      let hotQue = ''
    
      Object.keys(this.selected).forEach(i => {
        const type = this.selected[i]

        if (type === 'cate') {
          cateQue += `${i}_`
        }
        if (type === 'brand') {
          brandQue += `${i}_`
        }
        if (type === 'hot') {
          hotQue += `${i}_`
        }
      })

      return `${cateQue},${brandQue},${hotQue}`
    },
  }
}
</script>

<style lang="stylus">
.header-wechat
  display none
</style>



// WEBPACK FOOTER //
// nav.vue?5cb78a55